import { render, staticRenderFns } from "./reporteinstitucionbarra.vue?vue&type=template&id=bd837592"
import script from "./reporteinstitucionbarra.vue?vue&type=script&lang=js"
export * from "./reporteinstitucionbarra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports